import { gql } from "@apollo/client";

export const EDIT_CHAT_SETTINGS = gql`
    mutation EditChatSettings($id: ID!, $graphEnabled: Boolean, $companyContextEnabled: Boolean, $gptOnlyEnabled: Boolean) {
        editChatSettings(id: $id, graphEnabled: $graphEnabled, companyContextEnabled: $companyContextEnabled, gptOnlyEnabled: $gptOnlyEnabled) {
            id
            graphEnabled
            companyContextEnabled
            gptOnlyEnabled
            settings
        }
    }
`;